import { useState } from "react";
import { Link } from "react-router-dom";
import { Flame } from "lucide-react";
import { api, fmtErr } from "../lib/api";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(fmtErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0b0b0c] px-4">
      <div className="athanor-card w-full max-w-md p-8 fade-up">
        <div className="mb-6 flex items-center gap-3">
          <Flame className="h-5 w-5 text-[#C5A059]" />
          <h1 className="font-display text-xl font-bold text-slate-50">Reimposta password</h1>
        </div>
        {sent ? (
          <p data-testid="forgot-sent-message" className="text-sm text-slate-300">
            Se l'email è registrata, abbiamo inviato un link di reimpostazione. Controlla la casella di posta.
          </p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="mb-1 block text-xs text-slate-400">Email</label>
              <input data-testid="forgot-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                className="w-full rounded-md border border-zinc-800 bg-zinc-900/50 px-3 py-2.5 text-sm text-slate-100 outline-none focus:border-[#C5A059]/60" />
            </div>
            {error && <div className="text-sm text-red-400">{error}</div>}
            <button type="submit" disabled={loading} data-testid="forgot-submit-button" className="btn-bronze w-full rounded-md py-2.5 text-sm">
              {loading ? "Invio..." : "Invia link di reimpostazione"}
            </button>
          </form>
        )}
        <div className="mt-5 text-center">
          <Link to="/login" data-testid="back-to-login" className="text-xs text-slate-500 hover:text-[#C5A059]">
            Torna al login
          </Link>
        </div>
      </div>
    </div>
  );
}

export function ResetPassword() {
  const [password, setPassword] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const token = new URLSearchParams(window.location.search).get("token") || "";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
    } catch (err) {
      setError(fmtErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0b0b0c] px-4">
      <div className="athanor-card w-full max-w-md p-8 fade-up">
        <div className="mb-6 flex items-center gap-3">
          <Flame className="h-5 w-5 text-[#C5A059]" />
          <h1 className="font-display text-xl font-bold text-slate-50">Nuova password</h1>
        </div>
        {done ? (
          <div>
            <p data-testid="reset-done-message" className="text-sm text-emerald-400">Password aggiornata con successo.</p>
            <Link to="/login" data-testid="reset-goto-login" className="btn-bronze mt-4 inline-block rounded-md px-5 py-2.5 text-sm">
              Vai al login
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="mb-1 block text-xs text-slate-400">Nuova password (min. 8 caratteri)</label>
              <input data-testid="reset-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8}
                className="w-full rounded-md border border-zinc-800 bg-zinc-900/50 px-3 py-2.5 text-sm text-slate-100 outline-none focus:border-[#C5A059]/60" />
            </div>
            {error && <div data-testid="reset-error" className="text-sm text-red-400">{error}</div>}
            <button type="submit" disabled={loading || !token} data-testid="reset-submit-button" className="btn-bronze w-full rounded-md py-2.5 text-sm">
              {loading ? "Salvataggio..." : "Reimposta password"}
            </button>
          </form>
        )}
        <div className="mt-5 text-center">
          <Link to="/login" className="text-xs text-slate-500 hover:text-[#C5A059]">Torna al login</Link>
        </div>
      </div>
    </div>
  );
}
